import routerOptions0 from "/home/runner/work/sukrit-ecosystem-monorepo/sukrit-ecosystem-monorepo/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@20.8.3_eslint@8.57.0_ioredis@5.4.1_magicast@0.3_jbhvqhb727spls26o4dy5kfn7i/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}